import { render, staticRenderFns } from "./bf-rush.vue?vue&type=template&id=45bd6a6d&"
import script from "./bf-rush.vue?vue&type=script&lang=js&"
export * from "./bf-rush.vue?vue&type=script&lang=js&"
import style0 from "./bf-rush.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports